export default __webpack_public_path__ + "static/media/multiplayerIcon.79308aa8.png";